import React from "react";

const AboutHero = () => {
  return (
    <div className="about_hero">
      <div className="about_hero_content">
        <h2 style={{fontSize:"32px"}}>
          <span style={{color:"oklch(62.3% 0.214 259.815)", fontSize:"16px"}}>About Metbrains</span><br />
          <em>Empowering Careers Through<br/> Applied Mentorship</em>
        </h2>
        <p style={{marginBlock:"20px"}}>
        Practical, mentor-led learning that equips you for tomorrow’s opportunities.
        </p>
        <button>Contact us</button>
      </div>
    </div>
  );
};

export default AboutHero;
